import {HTTP} from "@/http";

class ReportCategoryService {
  basePath = 'api/v2/report-categories';

  /**
   * Get all report categories
   * @param {string} [tenantId] - Optional tenant ID filter for superadmins
   * @returns {Promise<Object>} Promise that resolves to the categories response
   */
  getAll(tenantId = null) {
    const params = tenantId ? { tenantId, expand: true } : { expand: true };
    return HTTP.get(this.basePath, { params });
  }

  /**
   * Get a report category by ID
   * @param {string} id - The category ID
   * @returns {Promise<Object>} Promise that resolves to the category
   */
  getById(id) {
    return HTTP.get(`${this.basePath}/${id}`);
  }

  /**
   * Create a new report category
   * @param {Object} category - The category to create
   * @returns {Promise<Object>} Promise that resolves to the created category
   */
  create(category) {
    return HTTP.post(this.basePath, category);
  }

  /**
   * Update a report category
   * @param {string} id - The category ID to update
   * @param {Object} category - The updated category data
   * @returns {Promise<Object>} Promise that resolves to the updated category
   */
  update(id, category) {
    return HTTP.patch(`${this.basePath}/${id}`, category);
  }

  /**
   * Delete a report category
   * @param {string} id - The category ID to delete
   * @returns {Promise<Object>} Promise that resolves when the category is deleted
   */
  delete(id) {
    return HTTP.delete(`${this.basePath}/${id}`);
  }
}

/**
 * @type {ReportCategoryService}
 */
export const reportCategoryService = new ReportCategoryService();
